import React, { useEffect, useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaBars, FaLock } from "react-icons/fa";
import { FaLockOpen } from "react-icons/fa6";

import logo from "../images/TP-_logo-orizz-claim-color-white-text.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/TP-_logo-symbol-white.png";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));

    const intervalId = isLocked
      ? setInterval(() => {
          // CHIUSO: aggiorna la pagina corrente.
          window.location.reload();
        }, 150000)
      : setInterval(() => {
          // APERTO: torna ad Amotive.
          window.location.href = "/amotive";
        }, 150000);

    return () => clearInterval(intervalId);
  }, [isLocked]);

  return (
    <Navbar
      expand="lg"
      className="ord-navbar m-3 mb-0 mt-2 px-4 py-2 border-0"
    >
      <Container fluid className="p-0">
        <Navbar.Brand
          as={Link}
          to="/home"
          className="d-flex align-items-center"
        >
          <img
            src={logo}
            alt="Technoparts"
            className="ord-navbar-logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-responsive-ordini"
          className="border-0 shadow-none ord-navbar-toggle"
        >
          <FaBars />
        </Navbar.Toggle>

        <Navbar.Collapse id="navbar-responsive-ordini">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center w-100 mt-3 mt-lg-0">
            <div className="d-flex flex-wrap align-items-center gap-3 ms-lg-4">
              <Link
                to="/technoparts"
                className="ord-nav-link text-decoration-none"
              >
                <img
                  src={logoInvert3}
                  alt=""
                  className="ord-brand-icon"
                />
                TECHNOPARTS
              </Link>

              <Link
                to="/sud-ricambi"
                className="ord-nav-link text-decoration-none"
              >
                <img
                  src={logoInvert}
                  alt=""
                  className="ord-brand-icon"
                />
                SUD RICAMBI
              </Link>

              <Link
                to="/amotive"
                className="ord-nav-link text-decoration-none"
              >
                <img
                  src={logoInvert2}
                  alt=""
                  className="ord-brand-icon"
                />
                AMOTIVE
              </Link>
            </div>

            <div className="d-flex align-items-center gap-2 ms-auto mt-3 mt-lg-0">
              <div className="ord-nav-separator d-none d-lg-block" />

              <button
                type="button"
                onClick={() => setIsLocked((prev) => !prev)}
                className={`ord-lock-btn ${
                  isLocked ? "is-locked" : "is-unlocked"
                }`}
                title={
                  isLocked
                    ? "Sessione chiusa - clicca per aprire"
                    : "Sessione aperta - clicca per chiudere"
                }
                aria-label={isLocked ? "Apri sessione" : "Chiudi sessione"}
                aria-pressed={!isLocked}
              >
                {isLocked ? <FaLock /> : <FaLockOpen />}
              </button>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .ord-navbar {
          position: relative !important;
          z-index: 1030 !important;
          min-height: 58px !important;
          border-radius: 18px !important;
          overflow: visible !important;

          background:
            linear-gradient(
              135deg,
              rgba(0, 0, 0, 0.98),
              rgba(0, 0, 0, 0.96)
            ) !important;

          border:
            1px solid rgba(255,255,255,0.10) !important;

          box-shadow:
            0 12px 28px rgba(0,0,0,0.22),
            inset 0 1px 0 rgba(255,255,255,0.14) !important;

          backdrop-filter:
            blur(18px)
            saturate(130%);

          -webkit-backdrop-filter:
            blur(18px)
            saturate(130%);
        }

        .ord-navbar > .container-fluid,
        .ord-navbar .navbar-collapse {
          overflow: visible !important;
        }

        .ord-navbar-logo {
          display: block;
          height: 30px;
          width: auto;
          object-fit: contain;
        }

        .ord-navbar-toggle {
          color: #fff !important;
        }

        .ord-navbar-toggle svg {
          color: #fff !important;
        }

        .ord-nav-link {
          display: flex;
          align-items: center;
          color: rgba(255,255,255,0.90) !important;
          font-size: 0.75rem;
          font-weight: 650;
          transition:
            color 0.18s ease,
            transform 0.18s ease;
        }

        .ord-nav-link:hover {
          color: #fff !important;
          transform: translateY(-1px);
        }

        .ord-brand-icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          object-fit: contain;
          filter: brightness(0) invert(1);
        }

        .ord-nav-separator {
          width: 1px;
          height: 20px;
          margin: 0 5px;
          background: rgba(255,255,255,0.30);
        }

        .ord-lock-btn {
          width: 36px;
          min-width: 36px;
          height: 36px;
          padding: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          cursor: pointer;
          transition:
            transform 0.18s ease,
            background 0.18s ease,
            color 0.18s ease,
            border-color 0.18s ease;
        }

        /* CHIUSO = blocco bianco + lucchetto rosso */
        .ord-lock-btn.is-locked {
          color: #b81f25 !important;
          background: #fff !important;
          border: 1px solid rgba(255,255,255,0.98) !important;
          box-shadow:
            0 5px 14px rgba(73,13,17,0.18),
            inset 0 1px 0 rgba(255,255,255,1) !important;
        }

        .ord-lock-btn.is-locked svg {
          color: #b81f25 !important;
          fill: currentColor !important;
        }

        .ord-lock-btn.is-locked:hover {
          color: #98191f !important;
          background: #f6f6f6 !important;
          transform: translateY(-1px);
        }

        /* APERTO = glass + lucchetto bianco */
        .ord-lock-btn.is-unlocked {
          color: #fff !important;
          background: rgba(255,255,255,0.12) !important;
          border: 1px solid rgba(255,255,255,0.18) !important;
        }

        .ord-lock-btn.is-unlocked svg {
          color: #fff !important;
          fill: currentColor !important;
        }

        .ord-lock-btn.is-unlocked:hover {
          background: rgba(255,255,255,0.22) !important;
          transform: translateY(-1px);
        }

        #navbar-responsive-ordini {
          position: relative;
          z-index: 1035;
          background: transparent !important;
          overflow: visible !important;
        }

        @media screen and (max-width: 991px) {
          .ord-navbar {
            margin: 6px 7px 0 !important;
            padding: 8px 14px !important;
            border-radius: 17px !important;
          }

          .ord-navbar .navbar-collapse {
            overflow: visible !important;
          }
        }
      `}</style>
    </Navbar>
  );
}

export default BasicExample;
